import { siteConfig } from '@/mocks/home';

export default function DownloadCTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Dynamic%20gradient%20background%20with%20warm%20coral%20and%20amber%20tones%2C%20abstract%20flowing%20shapes%2C%20modern%20minimalist%20design%2C%20energetic%20and%20vibrant%20atmosphere%2C%20soft%20geometric%20patterns%2C%20warm%20inviting%20colors%2C%20clean%20composition&width=1920&height=600&seq=cta-bg-91short&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-800/90 to-accent-800/90"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          准备好开启你的短视频之旅了吗？
        </h2>
        <p className="text-background-50/80 text-lg mb-10">
          立即下载91short，加入5000万创作者社区，发现属于你的精彩世界
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={siteConfig.downloadUrl}
            className="w-full sm:w-auto px-8 py-4 rounded-full bg-background-50 text-primary-700 text-base font-semibold hover:bg-background-100 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
          >
            <i className="ri-apple-line mr-2"></i>
            App Store 下载
          </a>
          <a
            href={siteConfig.downloadUrl}
            className="w-full sm:w-auto px-8 py-4 rounded-full bg-background-50/15 backdrop-blur-sm border-2 border-background-50/40 text-background-50 text-base font-semibold hover:bg-background-50/25 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-android-line mr-2"></i>
            Android 下载
          </a>
        </div>

        <p className="text-background-50/50 text-xs mt-6">
          支持 iOS 15+ 和 Android 10+ 系统
        </p>
      </div>
    </section>
  );
}